import { Injectable, OnInit } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MagicStringService implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
